import { type OrderDetails } from "@koala/sdk";

declare global {
  interface Window {
    rkp: (event: string, ...args: any[]) => void;
  }
}

const hasRoku = () => {
  return typeof window !== "undefined" && window.rkp;
};

interface RokuContentItem {
  id: string;
  quantity: number;
  price?: number;
  delivery_category?: string;
}

type RokuDeliveryCategory = "in_store" | "curbside" | "home_delivery";

export class RokuAnalytics {
  /**
   * Maps our conveyance types to Roku's delivery categories
   */
  private static mapDeliveryCategory(
    conveyanceType: string
  ): RokuDeliveryCategory | undefined {
    switch (conveyanceType) {
      case "pick_up":
        return "in_store";
      case "curbside":
        return "curbside";
      case "delivery":
        return "home_delivery";
      default:
        return undefined;
    }
  }

  /**
   * Page View Event
   */
  static pageView() {
    if (!hasRoku()) {
      return;
    }

    window.rkp("event", "PAGE_VIEW");
  }

  /**
   * Commerce Events
   */
  static purchase(orderDetails: OrderDetails) {
    if (!hasRoku()) {
      return;
    }

    const deliveryCategory = RokuAnalytics.mapDeliveryCategory(
      orderDetails.order_data.basket.conveyance_type.type
    );

    // Convert basket items to Roku content format
    const contents: RokuContentItem[] =
      orderDetails.order_data.basket.basket_items.map((item) => {
        const contentItem: RokuContentItem = {
          id: item.product.id.toString(),
          quantity: item.quantity,
        };

        // Only include delivery_category if it's defined
        if (deliveryCategory) {
          contentItem.delivery_category = deliveryCategory.toUpperCase();
        }

        return contentItem;
      });

    window.rkp("event", "PURCHASE", {
      value: orderDetails.order_data.order.total / 100, // Convert cents to dollars
      order_id: orderDetails.order_data.order.id,
      contents,
    });
  }
}
